import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CorteVenta;
export interface Props extends kea.ModalProps<number | undefined, false | "resumen" | "detalle", undefined> {
}

/**
 * Valida un CorteVenta
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un CorteVenta
*/
export class GenerarReporteEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    onCerrar = () => {
        this.props.onClose(false);
    }

    onHandleVendedorChange = async (idVendedor: number) => {
        this.props.onChange(idVendedor);
    }


    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);

        return (
            <kea.Modal
                buttons={[
                    <kea.Button style="success" children="Detalle" onClick={() => this.props.onClose("detalle")} />,
                    <kea.Button style="success" children="Resumen" onClick={() => this.props.onClose("resumen")} />,
                ]}
                onClose={this.onCerrar}
                title="Generar reporte de comisiones"
            >

                <selectores.Vendedor value={this.props.value} label="Seleccionar vendedor o vacío para todos:" onChange={this.onHandleVendedorChange} />

            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/corteventas/list/modalGenerarReporte.tsx